import type { ExperimentAssignment, ExperimentsData } from '@/components/_shared/contexts/ExperimentsContext';
import { LISTINGS_VIBE_FIRST_EXPERIMENT } from '../../common/constants';

export function isListingsVibeFirstVariant(assignment: ExperimentAssignment | undefined): boolean {
  return assignment?.groupName?.toLowerCase() === 'test';
}

export function getListingsVibeFirstFromExperiments(experiments: ExperimentsData | undefined): boolean {
  if (!experiments) {
    return false;
  }
  return isListingsVibeFirstVariant(experiments[LISTINGS_VIBE_FIRST_EXPERIMENT.experimentName]);
}
